/* GVLLOW Theme - Main JavaScript */

(function() {
  'use strict';

  // Initialize global namespace
  window.gvllowTheme = window.gvllowTheme || {};

  /* ============================================================================
     Cart Functionality
     ========================================================================== */

  gvllowTheme.cart = {
    drawer: null,
    
    init: function() {
      this.drawer = document.getElementById('cart-drawer');
      this.bindEvents();
    },

    bindEvents: function() {
      // Cart icon click
      const cartIcons = document.querySelectorAll('.cart-icon');
      cartIcons.forEach(icon => {
        icon.addEventListener('click', (e) => {
          e.preventDefault();
          this.openDrawer();
        });
      });

      // Close cart on overlay click
      if (this.drawer) {
        this.drawer.addEventListener('click', (e) => {
          if (e.target === this.drawer) {
            this.closeDrawer();
          }
        });
      }
    },

    openDrawer: function() {
      if (this.drawer) {
        this.drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.loadCart();
      }
    },

    closeDrawer: function() {
      if (this.drawer) {
        this.drawer.classList.remove('active');
        document.body.style.overflow = '';
      }
    },

    loadCart: function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          this.renderCart(cart);
        })
        .catch(error => {
          console.error('Error loading cart:', error);
        });
    },

    renderCart: function(cart) {
      const cartItemsContainer = document.getElementById('cart-items');
      const cartTotalElement = document.getElementById('cart-total');
      
      if (!cartItemsContainer) return;

      if (cart.items.length === 0) {
        cartItemsContainer.innerHTML = '<p style="text-align: center; color: #999;">Your cart is empty</p>';
      } else {
        const itemsHTML = cart.items.map(item => `
          <div class="cart-item" style="display: flex; gap: 1rem; margin-bottom: 1rem; padding-bottom: 1rem; border-bottom: 1px solid rgba(220, 20, 60, 0.2);">
            <img src="${item.image}" alt="${item.title}" style="width: 80px; height: 80px; object-fit: cover;">
            <div style="flex: 1;">
              <h4 style="margin: 0 0 0.5rem 0; font-size: 0.95rem;">${item.product_title}</h4>
              ${item.variant_title !== 'Default Title' ? `<p style="margin: 0; font-size: 0.85rem; color: #999;">${item.variant_title}</p>` : ''}
              <p style="margin: 0.5rem 0; font-size: 0.9rem; color: #dc143c;">${this.formatMoney(item.final_line_price)}</p>
              <div style="display: flex; gap: 0.5rem; align-items: center; margin-top: 0.5rem;">
                <button onclick="window.gvllowTheme.cart.updateQuantity(${item.key}, ${item.quantity - 1})" 
                        style="background: #dc143c; border: none; color: white; padding: 0.25rem 0.5rem; cursor: pointer;">-</button>
                <span style="min-width: 30px; text-align: center;">${item.quantity}</span>
                <button onclick="window.gvllowTheme.cart.updateQuantity(${item.key}, ${item.quantity + 1})" 
                        style="background: #dc143c; border: none; color: white; padding: 0.25rem 0.5rem; cursor: pointer;">+</button>
                <button onclick="window.gvllowTheme.cart.updateQuantity(${item.key}, 0)" 
                        style="background: transparent; border: none; color: #dc143c; padding: 0.25rem 0.5rem; cursor: pointer; margin-left: auto;">Remove</button>
              </div>
            </div>
          </div>
        `).join('');
        
        cartItemsContainer.innerHTML = itemsHTML;
      }

      if (cartTotalElement) {
        cartTotalElement.textContent = this.formatMoney(cart.total_price);
      }

      // Update cart count badge
      const cartCountElement = document.getElementById('cart-count');
      if (cartCountElement) {
        cartCountElement.textContent = cart.item_count;
        cartCountElement.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    },

    updateQuantity: function(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        this.renderCart(cart);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    },

    formatMoney: function(cents) {
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
  };

  // Expose cart close function globally for onclick handlers
  window.gvllowTheme.closeCart = function() {
    gvllowTheme.cart.closeDrawer();
  };

  /* ============================================================================
     Product Card Navigation
     ========================================================================== */

  gvllowTheme.products = {
    init: function() {
      const productCards = document.querySelectorAll('.product-card');
      productCards.forEach(card => {
        card.addEventListener('click', (e) => {
          // Don't navigate if clicking on form elements
          if (e.target.closest('form') || e.target.closest('button')) {
            return;
          }
          
          const url = card.getAttribute('data-product-url');
          if (url) {
            window.location.href = url;
          }
        });
      });
    }
  };

  /* ============================================================================
     Mobile Menu Toggle
     ========================================================================== */

  gvllowTheme.mobileMenu = {
    init: function() {
      // Add mobile menu functionality if needed
    }
  };

  /* ============================================================================
     Initialize on DOM Ready
     ========================================================================== */

  function init() {
    gvllowTheme.cart.init();
    gvllowTheme.products.init();
    gvllowTheme.mobileMenu.init();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ============================================================================
     Smooth Scroll for Anchor Links
     ========================================================================== */

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#!') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  /* ============================================================================
     Image Lazy Loading Fallback
     ========================================================================== */

  if ('loading' in HTMLImageElement.prototype) {
    // Browser supports native lazy loading
  } else {
    // Fallback for older browsers
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.src;
    });
  }

})();
